//export const getAuthToken = (state) => state.auth.authToken;
export const getIsLoggedIn = (state) => !!state.auth.clientHashId;
export const getAccessToken = (state) => state.auth.accessToken;
export const getUserEmail = (state) => state.auth.userEmail;
export const getUserInfo = (state) => state.auth.userInfo;
export const getLinkedAccountsResponse = (state) => state.auth.linkedAccountsResponse;